import styled from 'styled-components';

export const Column = styled.div`
  flex: ${props => props.flex};
  padding: 0 5px;
  ${props => {
    if (!props.col) {
      return;
    }
    const mw = (props.col * 100) / 12;
    return `
      max-width: ${mw}%;
      flex: 0 0 ${mw}%;
    `;
  }}
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;


// WEBPACK FOOTER //
// ./src/components/ui/layout.js